import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { Course } from 'src/app/models/course';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { PracticeService } from 'src/app/services/practice.service';
import { Practice } from 'src/app/models/practice';
import { VimeoService } from 'src/app/services/vimeo.service';
import { MediaService } from 'src/app/services/media.service';
import { LessonService } from 'src/app/services/lesson.service';
import { Lesson } from 'src/app/models/lesson';

@Component({
  selector: 'app-practice-content-lessons',
  templateUrl: './practice-content-lessons.component.html',
  styleUrls: ['./practice-content-lessons.component.scss']
})
export class PracticeContentLessonsComponent implements OnInit {
  public practiceId;
  public practice;
  public loadedPractice:boolean=false;
  public loadedCourse:boolean = false;
  public course: Course;
  private courseId;
  public media={};

  constructor(
    private _practice: PracticeService,
    private courseService: CourseService,
    private _notify: NotificationService,
    private _vimeo: VimeoService,
    private _media: MediaService,
    private route: ActivatedRoute,
    private _lesson: LessonService
  ) {
    this.practiceId = this.route.snapshot.paramMap.get("practiceId");
    this.courseId = this.route.snapshot.paramMap.get("courseId");
  }

  public getVimeoThumbnail(vimeoId:number, mediaId:number){
    this._vimeo.getVimeoThumbnail(vimeoId).subscribe(
      (data:any) => {
        if(data.status=='ok' && mediaId != 1) {
          this._media.updateMediaUrl(mediaId,data.thumbnail).subscribe(
            res => {
              this.media[mediaId]=data.thumbnail;
              this._notify.showMessage('Thumbnail refreshed', 'OK');
            }
          );
        }
      }
    );
  }

  public getVimeoData(vimeoId:number, lessonId:number, lessonIndex:number){
    this._vimeo.getVimeoVideo(vimeoId).subscribe(
      (data:any) => {
        if (data.duration) {
          this.course.lessons[lessonIndex].duration=data.duration;
          this._notify.showMessage('Video Metadata refreshed. Save changes to update the system.', 'OK');
        }
      }
    );
  }

  public addLesson(){
    this._lesson.addLesson(this.course.id, this.course.lessons.length).subscribe(
      (res:Lesson) => {
        this.course.lessons.push(new Lesson(res));
        this._notify.showMessage('New course lesson added.', 'OK');
      }
    );
  }

  public deleteLesson(lessonId:number, lessonIndex:number){
    if(confirm('Please confirm you wish to delete this lesson?')){
      this._lesson.deleteLesson(lessonId).subscribe(
        (res:any) => {
          if (res.status=='deleted') {
            this.course.lessons.splice(lessonIndex, 1);
            this._notify.showMessage('Lesson deleted.', 'OK');
          }
          if (res.status=='failed') {
            this._notify.showMessage('Failed to delete lesson.', 'Oh...');
          }
        }
      );
    }
  }

  public getPractice(){
    this._practice.getPractice(this.practiceId).subscribe(
      res=>{
        this.practice=new Practice(res);
        this.loadedPractice=true;
      }
    );
  }

  ngOnInit() {
    this.getPractice();
    this.courseService.getCourse(this.courseId).subscribe(course=>{
      this.course=course;
      this.course.lessons.forEach(lesson => {
        this._media.getMediaUrl(lesson.media_id).subscribe((res:any) => {
          if (res.status=='ok') {
            if(res.media_url == '/assets/imgs/default-icon.png') res.media_url = 'assets/imgs/default-icon.png';
            this.media[lesson.media_id]=res.media_url;
          }
        });
      });
      this.loadedCourse = true;
    });
  }

  public saveChanges(){
    let doSave=true;
    this.course.lessons.forEach(lesson=>{
      if(lesson.title=='') {
        doSave=false;
        return this._notify.showMessage('All lessons must have a title.', 'OK');
      }
      if(!lesson.vimeo_id) {
        doSave=false;
        return this._notify.showMessage('All lessons must have a Vimeo ID.', 'OK');
      }
    });
    if(!doSave) return;
    this._lesson.updateLessons(this.course.lessons).subscribe(
      res=>{
        console.log(res);
      }
    );
  }
}